<template>
  <a-checkbox-group v-model:value="checkedList" :options="options" />
</template>
<script setup lang="ts">
import { StaffPost } from '@src/scripts/type'
import { computed } from 'vue'

const props = defineProps<{
  value: number
}>()

const emit = defineEmits(['update:value'])

const checkedList = computed({
  get() {
    const arr = []
    if (props.value & StaffPost.manager) arr.push(StaffPost.manager)
    if (props.value & StaffPost.waiter) arr.push(StaffPost.waiter)
    if (props.value & StaffPost.cashier) arr.push(StaffPost.cashier)
    if (props.value & StaffPost.cooker) arr.push(StaffPost.cooker)
    return arr
  },
  set(arr) {
    let sum = 0
    arr.forEach(a => sum += a)
    emit('update:value', sum)
  }
})

const options = [
  { label: '管理员', value: 1 },
  { label: '服务员', value: 2 },
  { label: '收银员', value: 4 },
  { label: '厨师', value: 8 },
]


</script> 